import React, { ReactNode, useContext, useEffect, useState } from 'react';

import NetworkContext from '@totem/components/devices/network/networkContext';
import { NetworkInterface } from '@totem/components/networkConcerns/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const NetworkContainer = ({ id, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<NetworkInterface[]>([]);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<NetworkInterface>(null);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      const uri = `${DEVICES_ENDPOINT}/${id}/network-interfaces`;

      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: NetworkInterface[]) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id, refreshData, getApiToken]);

  const handleAction = (newAction: string, item: NetworkInterface) => {
    switch (newAction) {
      case 'refresh':
        setRefreshData(true);
        break;
      default:
        setAction(newAction);

        setActionItem(item);
    }
  };

  return (
    <NetworkContext.Provider
      value={{
        deviceId: id,
        loading: isLoading,
        data,
        action,
        actionItem,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </NetworkContext.Provider>
  );
};

export default NetworkContainer;
